import React  from 'react'
import { InputSingleTextNextButton } from '../../../../../../../ui/organisms'

export default {
  title: 'Please name the financier on this project?',
  next: 'projectInfo.projectName',
  component: (props) => <InputSingleTextNextButton placeHolder={"Financier's name"} {...props}/>
}